import React from 'react';
import DisplayDocument, {
  fieldsContext,
} from 'hellospa/components/signature-request';
import wrapPage from './wrap-page';
import GroupedFields from './grouped-fields';

function SignerDocument() {
  const fields = React.useContext(fieldsContext);

  const groupedFields = React.useMemo(() => {
    return fields.reduce((groups, f) => {
      if (f.group != null) {
        groups[f.group] = groups[f.group] || [];
        groups[f.group].push(f);
      }
      return groups;
    }, {});
  }, [fields]);

  return (
    <DisplayDocument wrapPage={wrapPage}>
      <GroupedFields groupedFields={groupedFields} />
    </DisplayDocument>
  );
}

export default React.memo(SignerDocument);
